<template>
  <section @click="click($event)" v-show="modalOpen" :class="style.modal">
    <div :class="style.mainBlock">
      <buttonCross
        style="position: absolute; top: -30px; right: -30px"
        @click="off()"
      />
      <slot />
    </div>
  </section>
</template>
<script lang="ts">
import {defineComponent} from "vue";
import style from "./ModalBlock.module.scss";
export default defineComponent({
  props: ["model"],
  data() {
    return {
      style,
      modalOpen: false
    };
  },
  created() {
    this.modalOpen = this.model;
    document.addEventListener("keyup", this.handleEscClose);
  },

  beforeUnmount() {
    document.removeEventListener("keyup", this.handleEscClose);
  },
  methods: {
    click(e: Event) {
      const target = e.target as HTMLElement;
      const classList = Array.from(target.classList);
      if (classList.includes(this.style.modal)) {
        this.off();
      }
    },
    handleEscClose(e: KeyboardEvent) {
      if (this.modalOpen && e.key == "Escape") {
        this.off();
      }
    },
    off() {
      this.modalOpen = false;
    }
  },
  watch: {
    model(data) {
      this.modalOpen = data;
      if (data && window.innerWidth > 430) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
    },
    modalOpen(data) {
      this.$emit("update:modelValue", data);
    }
  }
});
</script>
